const NAME = "PERFORMANCE_ANALYTICS_EVALUATIONS";

export default NAME;